import React, { useEffect } from 'react';
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {connect, useSelector} from "react-redux";
import { Card, CardBody, CardTitle } from "reactstrap";
import {getStateByPath} from "../../../redux/selectors";

// components
import AdmissionFilters from "./_filter";
import TranslateButton from "../../../components/buttons/TranslateButton";
import { ActiveFormatter } from "../../../components/tables/activeFormater";
import {GenericButton} from "../../../components/buttons/customButtons";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";

// labels
import { LIST,  NO_DATA_FOUND} from "../../../components/i18n/i18n";
import { TT_DELETE, TT_EDIT } from "../../../components/i18n/toolTips";
import { FL_ACTIONS, FL_ALLOWED_TO_BUY, FL_CODE, FL_NAME, FL_STATUS } from "../../../components/i18n/formLabels";

// actions
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {setFilter, setForm, setItem, setTableParams} from "../../../redux/actions/generics/IndexedActions";

// services
import { admissionService } from "../../../jwt/_services/configuration/admissionService";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import AdmissionForm from "./_form";

const AdmissionList = props => {
    const {path} = props
    const componentState = useSelector(state => getStateByPath(state, path));
    const {app, udn, pageSize, pageIndex, totalSize, listDomainObjects, filter} = componentState?.data || {};

    useEffect( () => {
        if(filter || !app?.id || !udn?.id)
            return

        props.setFilter(path, {
            fbDataBase : { id: app?.fbDataBase?.id},
            item: {
                udn: { id : udn?.id },
                code: null
            }
        })
    }, [app, udn]);

    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, admissionService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter]);

    const editItem = data => {
        props.setItem(path, data);
        props.setForm(path, true, false, false);

        ModalFormContainer(AdmissionForm, { path, data, closeOnEscape:false, closeOnClickOutside: false})
    }

    const createItem = () => {
        props.setItem(path, null);
        props.setForm(path)

        ModalFormContainer(AdmissionForm, { path })
    }
    const handleTableChange = (type, {page, sizePerPage}) => {
        let currentIndex = (page - 1) * sizePerPage
        props.setTableParams(path, sizePerPage, currentIndex, totalSize, currentIndex )
    };

    const confirmDelete = data => ConfirmDelete({
        path,
        data,
        fbDataBaseId: app?.fbDataBase?.id,
        service: admissionService,
        remove : genericIndexedActions.delete,
    } );

    const actionsFormatter = (cell, row) => <>
        <GenericButton style={'table'} toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
        <TranslateButton item={row} service={admissionService} path={path}/>
        <GenericButton style={'danger-secondary'} toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
    </>

    const columns = [
        {
            dataField: 'id',
            text: 'ID',
            headerStyle: {width: '0px'},
            hidden: true
        }, {
            dataField: 'uid',
            text: 'uid',
            headerStyle: {width: '200px'},
        }, {
            dataField: 'name',
            text: `${FL_NAME}`,
        }, {
            dataField: 'code',
            text: `${FL_CODE}`
        }, {
            dataField: 'allowBuy',
            text: `${FL_ALLOWED_TO_BUY}`,
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '80px'},
            formatter: (cell) => <ActiveFormatter active={cell}/>
        }, {
            dataField: 'status',
            text: `${FL_STATUS}`,
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '50px'},
            formatter: (cell) => <ActiveFormatter active={cell}/>
        }, {
            dataField: 'actions',
            isDummyField: true,
            text: `${FL_ACTIONS}`,
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '250px'},
            formatter: actionsFormatter
        }
    ];

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"/>{LIST}
            <div className="float-right">
                <GenericButton
                    style={'table'}
                    label={'Agregar'}
                    toolTip={'Agregar'}
                    icon={'fa-plus'}
                    permission={'add'}
                    onClick={createItem}
                />
            </div>
        </CardTitle>

        <AdmissionFilters path={path} />

        <CardBody>
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={ columns }
                noDataIndication={NO_DATA_FOUND}
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={ handleTableChange }
            />
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setForm,
    setItem,
})

export default connect(mapStateToProps, mapActionsToProps)(AdmissionList)